import AdminDashboard from '../components/AdminDashboard.jsx';
import SellerDashboard from '../components/SellerDashboard.jsx';
import BuyerDashboard from '../components/BuyerDashboard.jsx';

export default function DashboardPage({ user, onViewProductById, onSwitchRole, onLogout, onUserUpdate }) {
    try {
        if (!user) {
            return <div className="text-center py-10"><i className="fas fa-spinner fa-spin text-3xl text-blue-400"></i></div>;
        }

        // Render different dashboards based on the user's active role
        switch (user.activeRole) {
            case 'admin':
                return <AdminDashboard user={user} onViewProductById={onViewProductById} />;
            case 'seller':
                return <SellerDashboard 
                            user={user} 
                            onSwitchRole={onSwitchRole} 
                            onLogout={onLogout} 
                            onUserUpdate={onUserUpdate} 
                        />;
            case 'buyer':
                // This now correctly calls the new, dynamic BuyerDashboard component from its own file.
                return <BuyerDashboard user={user} onViewProductById={onViewProductById} onSwitchRole={onSwitchRole} onLogout={onLogout} />;
            default:
                // Fallback for unknown roles
                return <div className="text-center py-10 text-red-500">Invalid user role. Please contact support.</div>;
        }
    } catch (error) {
        console.error('DashboardPage component error:', error);
        // reportError(error); // Assuming reportError is a global function
        return <div className="text-center py-10 text-red-500">Error loading dashboard.</div>;
    }
}
